import React from 'react';
import { TextField } from '@material-ui/core';

export default function Input({ compact, ...props }) {
  return (
    <TextField
      variant="outlined"
      size={compact ? 'small' : 'medium'}
      margin={compact ? 'none' : 'normal'}
      {...props}
    />
  );
}
